( function( app ) {
  const COMPONENT = {

    init: function() {
      this.setEqualHeights();
      this.bindEvents();
    },

    bindEvents: function() {
      let resizeTimer;

      window.addEventListener( 'resize', () => {
        clearTimeout( resizeTimer );
        resizeTimer = setTimeout( () => {
          this.setEqualHeights();
        }, 150 );
      } );
    },

    setEqualHeights: function() {
      const cards = document.querySelectorAll( '.horizontal-card__card' );
      if ( !cards.length ) return;

      let maxHeight = 0;

      cards.forEach( ( card ) => {
        card.style.height = 'auto';
      } );

      cards.forEach( ( card ) => {
        const height = card.offsetHeight;
        if ( height > maxHeight ) {
          maxHeight = height;
        }
      } );

      cards.forEach( ( card ) => {
        card.style.height = maxHeight + 'px';
      } );
    },

    finalize: function() {
    },
  };
  app.registerComponent( 'horizontal-cards', COMPONENT );
} )( app );
